import { render, staticRenderFns } from "./anbieter.vue?vue&type=template&id=21c878b2&scoped=true&"
import script from "./anbieter.vue?vue&type=script&lang=js&"
export * from "./anbieter.vue?vue&type=script&lang=js&"
import style0 from "./anbieter.vue?vue&type=style&index=0&id=21c878b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c878b2",
  null
  
)

export default component.exports